import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Error.module.scss';

const Error = ({ className, children, ...restProps }: HTMLAttributes<HTMLDivElement>) => (
  <div {...restProps} className={classNames(styles.error, className)}>
    {children}
  </div>
);

export default Error;
